module.exports = __webpack_public_path__ + "static/media/slide-2.f36585e5.jpg";